<template>
	<div>
	<loader v-if="loader" color="white"></loader>
		<div class="container">
			<div class="row">
				<div class="col-12 biz-title-container">
					<div class="container">
						<div class="biz-panel-title">
							<h3>Djelatnici</h3>
							<a href="#" data-toggle="modal" data-target="#addEmplModal" class="btn fs-btn dark-border small"><span class="fas fa-plus fa-fw"></span></a>
						</div>
					</div>
					<div class="col-12">
						<notify></notify>
					</div>
				</div>
			</div>
			<div class="row" v-if="user.salon != null">
				<div class="col-12 salon-container mb-3" v-for="(empl , index) in user.salon.employees" :key="index">
					<div class="container mb-3">
						<div class="row no-gutters">
							<div class="col-12">
								<table class="table table-hover table-borderless bizInfoTable">
									<tr>
										<th>Ime i prezime:</th>
										<td class="bizInfoInput"> <input type="text" v-model="empl.name"> </td>

									</tr>
									<tr>
										<th>Radno mjesto:</th>
										<td class="bizInfoInput"><input type="text" v-model="empl.place" placeholder="example hairdresser, makeup artist, tattoo artist..."></td>

									</tr>
									<tr>
										<th>Kontakt:</th>
										<td class="bizInfoInput"><input type="text" v-model="empl.contact"></td>
									</tr>
									<tr>
										<th>Usluge:</th>
										<td colspan="3" class="bizInfoInput">
											<a @click="setEmpl(empl)" href="#viewEmplModal" data-toggle="modal">Klikni za popis usluga</a>
										</td>
									</tr>
								</table>
							</div>
							<div class="col-12">
								<div class="btn-xs-group mt-2">
									<a href="#" @click="updateEmployee(empl)" class="btn fs-btn dark btn-xs-group-block">Ažuriraj</a>
									<a href="#" @click="deleteItem(empl.id)" class="btn fs-btn danger-border btn-xs-group-block">Izbriši</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal animated fadeIn" id="addEmplModal" tabindex="-1" role="dialog" aria-labelledby="bookModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header text-center">
						<h4 class="modal-title w-100 font-weight-bold">Dodaj djelatnika</h4>
						<button type="button" class="close" id="closeZaposlenici" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body mx-3">
						<form id="">
							<div class="row">
								<div class="col-12 mb-3">
									<input id="name" name="name" type="text" v-model="employee.name" class="form-control" placeholder="Ime zaposlenika" aria-label="name" aria-describedby="name" required>
								</div>
								<div class="col-12 mb-3">
									<input id="contact" name="contact" type="text" v-model="employee.contact" class="form-control" placeholder="Kontakt zaposlenika" aria-label="contact" aria-describedby="contact" required>
								</div>
								<div class="col-12 mb-3">
									<input id="place" name="place" type="text" v-model="employee.place" class="form-control" placeholder="Radno mjesto" aria-label="place" aria-describedby="place" required>
								</div>
								<div class="col-12 mb-3">
									<th>Usluge koje obavlja zaposlenik:</th>
									<div v-for="(service,index) in user.salon.services" :key="index" class="form-check">
										<div @click="setServices(service.name)">
											<input v-model="empl[service.name]" class="form-check-input add-services-employee" type="checkbox" :id="'inlineCheckboxr'+index">
											<label @click="setServices(service.name)" class="form-check-label" :for="'inlineCheckboxr'+index"><small>{{service.name}}</small></label>
										</div>
									</div>
								</div>
								<div class="col-12">
									<notify></notify>
								</div>
							</div>
							<button @click="save()" id="submit" type="button" class="fs-btn dark text-uppercase btn-lg btn-block">
								<span>Dodaj</span>
							</button>
						</form>
					</div>
					<div id="book-modal-footer" class="modal-footer">
					</div>
				</div>
			</div>
		</div>
		<div class="modal animated fadeIn" id="viewEmplModal" tabindex="-1" role="dialog" aria-labelledby="bookModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header text-center">
						<h4 class="modal-title w-100 font-weight-bold">Odaberi usluge</h4>
						<button type="button" class="close" data-dismiss="modal" id="emplmodalclose" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body mx-3" id="serviceList">
						<div v-for="(service,index) in user.salon.services" :key="index" class="form-check form-check-inline d-flex" style="justify-content:start">
							<label class="form-check-label " :for="'inlineCheckboxr'+empl.id+''+index">
								<input @click="setServicesEmpl(service.name)" v-model="empl.salon_service_list[service.name]" style="width:unset" class="form-check-input" type="checkbox" :id="'inlineCheckboxr'+empl.id+''+index">
								{{service.name}}
							</label>
						</div>
					</div>
					<div id="book-modal-footer" class="modal-footer">
						<button @click="updateEmployee(empl)" class="btn fs-btn dark">AŽURIRAJ</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex';
	export default {
		name: 'employee',
		computed: {
			...mapState({
				user: (state) => state.user,
				loader: (state) => state.loader,
				endpoint: (state) => state.endpoint,
				token: (state) => state.token,
			})
		},
		data() {
			return {
				employee: {
					name: '',
					salon: 0,
					place: '',
					services: '',
					contact: ''
				},
				empl: {
					services: '',
					salon_service_list: []
				}
			}
		},
		methods: {
			setEmpl(empl) {
				if (!empl.salon_service_list) {
					empl.salon_service_list = [];
					empl.services.split(',').forEach((d) => {
						empl.salon_service_list[d] = true;
					});

					console.log(empl);
				}

				this.user.salon.services.forEach(element => {
					empl.salon_service_list[element.name] = empl.salon_service_list[element.name] ? true : false;
				});

				console.log(empl);
				this.empl = empl;
			},
			setServicesEmpl(value) {
				var employees = this.user.salon.employees.map((empl) => {
					if (empl.id == this.empl.id) {
						if (!empl.services.split(',').find((d) => d == value)) {
							empl.services += value + ',';
							empl.salon_service_list[value] = false;
						} else {
							empl.services = empl.services.split(value + ',').join('');
							empl.salon_service_list[value] = true;
						}
					}
					return empl;
				});

				console.log(this.empl.salon_service_list);
				var temp = this.user;
				temp.salon.employees = employees;
				this.$store.user = temp;
			},
			setServices(value) {
				if (!this.employee.services.split('()').find((d) => d == value)) {
					this.employee.services += value + '()';
				} else {
					this.employee.services = this.employee.services.split(value + '()').join('');
				}
				console.log(this.employee.services)
			},
			save() {
				if (this.user.salon == null) {
					this.$store.commit('setNotification', {
						type: 2,
						msg: 'Potrebno je prvo ažurirati salon.'
					})
					return false;
				}


				if (this.employee.name.length == 0 || this.employee.place.length == 0 || this.employee.contact.length == 0) {
					this.$store.commit('setNotification', {
						type: 2,
						msg: 'Sva polja su obavezna!'
					})
					return false;
				}

				if (this.employee.services.length == 0) {
					console.log(this.employee.services)
					this.$store.commit('setNotification', {
						type: 2,
						msg: 'Odaberite usluge! Ako nema popisa usluga, prvo dodajte usluge salona.'
					})
					return false;
				}

				this.employee.services = this.employee.services.split('()').join(',');
				this.$store.state.loader = true;
				this.employee.salon = this.user.salon.id;
				this.$store.dispatch('post', {
						details: this.employee,
						endpoint: this.endpoint + 'add-employee?token=' + this.token
					})
					.then((data) => {
						// console.log(data);
						if (data.data.status) {
							this.$store.state.user.salon.employees.push(data.data.data);
							this.$store.commit('setUser', {
								user: this.$store.state.user,
								token: this.$store.state.token
							});
							this.employee = {
								name: '',
								salon: 0,
								place: '',
								services: '',
								contact: ''
							};
							this.$store.commit('setNotification', {
								type: 1,
								msg: data.data.message
							});
							window.location.href = "/vendor#zaposlenici";
							window.location.reload();
						}
						this.$store.state.loader = false;
					})
					.catch((error) => {
						// console.log(error.request);
						this.$store.dispatch("handleError", error);
						this.$store.state.loader = false;
					})
			},
			deleteItem(id) {
				if (!confirm("Jeste li sigurni da želite izbrisati ovog djelatnika?")) {
					return false;
				}
				this.$store.state.user.salon.employees = this.$store.state.user.salon.employees.filter((d) => d.id != id);

				this.$store.dispatch('get', this.endpoint + 'delete-employee/' + id + '?token=' + this.token)
					.then((data) => {
						// console.log(data);
						if (data.data.status) {
							this.$store.commit('setUser', {
								user: this.$store.state.user,
								token: this.$store.state.token
							});
							this.$store.commit('setNotification', {
								type: 1,
								msg: data.data.message
							});
						}
					})
					.catch((error) => {
						// console.log(error.request);
						this.$store.dispatch("handleError", error);
					})
			},
			updateEmployee(empl) {
				if (empl.name.length == 0 || empl.place.length == 0 || empl.services.length == 0 || empl.contact.length == 0) {
					this.$store.commit('setNotification', {
						type: 2,
						msg: 'Molimo vas ispunite sva potrebna polja.'
					})
					return false;
				}


				this.employee.salon = this.user.salon.id;

				this.$store.dispatch('post', {
						details: empl,
						endpoint: this.endpoint + 'update-employee/' + empl.id + '?token=' + this.token
					})
					.then((data) => {
						// console.log(data);
						if (data.data.status) {
							this.$store.state.user.salon.employees = this.$store.state.user.salon.employees.map((d) => {
								if (d.id == empl.id) {
									return data.data.data;
								}
								return d;
							});
							this.$store.commit('setUser', {
								user: this.$store.state.user,
								token: this.$store.state.token
							});
							this.employee = {
								name: '',
								salon: 0,
								place: '',
								services: '',
								contact: ''
							};
							this.$store.commit('setNotification', {
								type: 1,
								msg: data.data.message
							});
						}
						if (document.getElementById('emplmodalclose')) {
							document.getElementById('emplmodalclose').click();
						}
					})
					.catch((error) => {
						// console.log(error.request);
						this.$store.dispatch("handleError", error);
						if (document.getElementById('emplmodalclose')) {
							document.getElementById('emplmodalclose').click();
						}
					})
			},
		},
		created() {
			// console.log(this.user);
		}
	}

</script>
